export enum Roles {
  underwriter = "underwriter",
  loanOfficer = "loan_officer",
  loanProcessor = "loan_processor",
  creditCommittee = "credit_committee",
  // Waiver authorization is permission-based rather than job-role-based:
  // any user whose token carries these, regardless of job role, can
  // request / approve-reject-conditionally-approve a waiver.
  requestWaiver = "request_waiver",
  approveWaiver = "approve_waiver",
  // Same permission-based model as above, for the Loan Economics pricing
  // fields (Interest Rate / Final Toorak Price): any user whose token
  // carries this, regardless of job role, can view and edit them.
  updatePricing = "update_pricing"
}

export enum EscalationTarget {
  processor = "processor",
  underwriter = "underwriter",
  creditCommittee = "creditCommittee"
}
